import React from 'react';
import { Input, QuestionMark, SubmitButton, CustomLink, InputWrapper } from 'react-design-components';
import { HelpModal } from 'react-commons';
import { ButtonWrapper, ErrorMessage, Information } from '../Elements';
import { DeliveryHelp } from '../Help';
import useDelivery from './hooks/useDelivery';
import { FlowEnum, ComponentsEnum } from '../../types';
import { MainLayout } from '../MainLayout';

interface Props {
  nextUrl: string;
  progress?: number;
  flow?: FlowEnum;
}

const tenYearsAgoDate = new Date();
tenYearsAgoDate.setFullYear(tenYearsAgoDate.getFullYear() - 10);
const tenYearsAgo = tenYearsAgoDate.toISOString().split('T')[0];

const Delivery: React.FC<Props> = (props: Props) => {
  const { nextUrl, progress, flow } = props;

  const { classes, t, defaultDeliveryDate, onSkip, handleSubmit, register, errors, toggleHelpModal } =
    useDelivery(nextUrl);
  const { ref, name, onChange, onBlur } = register('deliveryDate', {
    min: { value: tenYearsAgo, message: t('validation_delivery_date') },
  });
  return (
    <MainLayout
      navigationId={ComponentsEnum.PERIOD}
      flow={flow}
      progress={progress}
      directAccess={false}
      t={t}
      pageTitle="delivery_page_title"
    >
      <HelpModal>
        <DeliveryHelp />
      </HelpModal>
      <div className={classes.alignBottom}>
        <QuestionMark onHelpClick={toggleHelpModal} title={t('delivery_title')}>
          <InputWrapper>
            <div className="errorWrapper">
              <Input
                className={classes.mediumWidth}
                type="date"
                defaultValue={defaultDeliveryDate}
                name={name}
                onBlur={onBlur}
                onChange={onChange}
                placeholder={t('delivery_date')}
                error={!!errors.deliveryDate}
                inputRef={ref}
              />
              {!!errors.deliveryDate && <ErrorMessage>{errors.deliveryDate.message}</ErrorMessage>}
            </div>
          </InputWrapper>
        </QuestionMark>

        <ButtonWrapper>
          <SubmitButton onClick={handleSubmit}>{t('continue')}</SubmitButton>
          <Information>
            {t('or')}
            &nbsp;
            <CustomLink href="#/" onClick={onSkip} color="inherit" underline="always">
              {t('skip')}
            </CustomLink>
          </Information>
        </ButtonWrapper>
      </div>
    </MainLayout>
  );
};

export default Delivery;
